export enum PaymentSchedule {
  UPFRONT = 'upfront',
  INSTALLMENT = 'installment',
  PURCHASE_ORDER = 'purchase_order',
}

export enum PaymentType {
  CARD = 'card',
  GOOGLE_PAY = 'google_pay',
  APPLE_PAY = 'apple_pay',
  CASH_APP_PAY = 'cash_app_pay',
}

export enum PreAuthFraudDecision {
  APPROVE = 'approve',
  DECLINE = 'decline',
}
